<template>
  <div class="contract-employee">
    <b-form-group
      :disabled="disabled || isDisabled"
      class="required-control"
    >
      <label for="input-name">Nhân viên bán hàng:</label>
      <i
        class="fas fa-exclamation-circle text-warning ml-2 icon-size"
        v-show="showWarning('Sale')"
        :title="'Nhân viên chưa được lưu'"
      ></i>
      <Autosuggest
        :disabled="disabled || isDisabled"
        :model.sync="contractEmployeeInfo.saleName"
        :suggestions="filteredEmployeeOptions"
        :placeholder="'Nhân viên bán hàng'"
        :limit="10"
        @select="onSelected($event, 'Sale')"
        @change="onInputChange"
        @focus="onFocusInput(jobTitle.TVBH)"
      >
        <template #custom="{ suggestion }">
          <div>
            <span>{{ suggestion.item.fullName }}</span>
            <span class="text-primary" v-if="suggestion.item.code">
              - {{ suggestion.item.code }}
            </span>
          </div>
        </template>
      </Autosuggest>
    </b-form-group>
    <!--
      Phase B (2026-05-13) — uncomment + relabel theo ngữ cảnh bán xe.
      Order: 2 vai trò REQUIRED (Sale + Shipper) đứng đầu, 4 vai trò còn lại (Trưởng
      nhóm BH / Sale admin / GĐ showroom / NV kỹ thuật) đặt phía dưới — required
      ngồi gần nhau giúp user scan field bắt buộc trước.

      Mapping DB column → label:
        saleId      → "Nhân viên bán hàng" (required *)
        shipperId   → "Nhân viên giao hàng" (KHÔNG bắt buộc — 2026-05-13 update)
        technicalId → "Trưởng nhóm bán hàng"
        cashierId   → "Sale admin"
        managerId   → "Giám đốc showroom"
        assistantId → "Nhân viên kỹ thuật" (KHÔNG bắt buộc — không show warning icon)
        accessoryStaffId → "Nhân viên CDPK" (HIDE — không dùng cho xe)
        customerReceptionId → "Tiếp đón khách hàng" (HIDE)

      `Contract` + `ContractRequest` entities đã có column 4 vai trò này (migration
      1778600000000-AddSalesRolesToContractAndRequest).
    -->
    <b-form-group>
      <label>Nhân viên giao hàng:</label>
      <i
        class="fas fa-exclamation-circle text-warning ml-2 icon-size"
        v-show="showWarning('Shipper')"
        :title="'Nhân viên chưa được lưu'"
      ></i>
      <Autosuggest
        :disabled="disabled || isDisabled"
        :model.sync="contractEmployeeInfo.shipperName"
        :suggestions="filteredEmployeeOptions"
        :placeholder="'Nhân viên giao hàng'"
        :limit="10"
        @select="onSelected($event, 'Shipper')"
        @change="onInputChange"
      >
        <template #custom="{ suggestion }">
          <div>
            <span>{{ suggestion.item.fullName }}</span>
            <span class="text-primary" v-if="suggestion.item.code">
              - {{ suggestion.item.code }}
            </span>
          </div>
        </template>
      </Autosuggest>
    </b-form-group>

    <b-form-group :disabled="disabled || isDisabled">
      <label>Trưởng nhóm bán hàng:</label>
      <i
        class="fas fa-exclamation-circle text-warning ml-2 icon-size"
        v-show="showWarning('Technical')"
        :title="'Nhân viên chưa được lưu'"
      ></i>
      <Autosuggest
        :disabled="disabled || isDisabled"
        :model.sync="contractEmployeeInfo.technicalName"
        :suggestions="filteredEmployeeOptions"
        :placeholder="'Trưởng nhóm bán hàng'"
        :limit="10"
        @select="onSelected($event, 'Technical')"
        @change="onInputChange"
        @focus="onFocusInput(jobTitle.KTPM)"
      >
        <template #custom="{ suggestion }">
          <div>
            <span>{{ suggestion.item.fullName }}</span>
            <span class="text-primary" v-if="suggestion.item.code">
              - {{ suggestion.item.code }}
            </span>
          </div>
        </template>
      </Autosuggest>
    </b-form-group>
    <b-form-group :disabled="disabled || isDisabled">
      <label>Sale admin:</label>
      <i
        class="fas fa-exclamation-circle text-warning ml-2 icon-size"
        v-show="showWarning('Cashier')"
        :title="'Nhân viên chưa được lưu'"
      ></i>
      <Autosuggest
        :disabled="disabled || isDisabled"
        :model.sync="contractEmployeeInfo.cashierName"
        :suggestions="filteredEmployeeOptions"
        :placeholder="'Sale admin'"
        :limit="10"
        @select="onSelected($event, 'Cashier')"
        @change="onInputChange"
        @focus="onFocusInput(jobTitle.KTBH)"
      >
        <template #custom="{ suggestion }">
          <div>
            <span>{{ suggestion.item.fullName }}</span>
            <span class="text-primary" v-if="suggestion.item.code">
              - {{ suggestion.item.code }}
            </span>
          </div>
        </template>
      </Autosuggest>
    </b-form-group>
    <b-form-group :disabled="disabled || isDisabled">
      <label>Giám đốc showroom:</label>
      <i
        class="fas fa-exclamation-circle text-warning ml-2 icon-size"
        v-show="showWarning('Manager')"
        :title="'Nhân viên chưa được lưu'"
      ></i>
      <Autosuggest
        :disabled="disabled || isDisabled"
        :model.sync="contractEmployeeInfo.managerName"
        :suggestions="filteredEmployeeOptions"
        :placeholder="'Giám đốc showroom'"
        :limit="10"
        @select="onSelected($event, 'Manager')"
        @change="onInputChange"
        @focus="onFocusInput(jobTitle.QL)"
      >
        <template #custom="{ suggestion }">
          <div>
            <span>{{ suggestion.item.fullName }}</span>
            <span class="text-primary" v-if="suggestion.item.code">
              - {{ suggestion.item.code }}
            </span>
          </div>
        </template>
      </Autosuggest>
    </b-form-group>
    <!-- KHÔNG bắt buộc (không có red *) nhưng vẫn show warning icon `!` khi
         rỗng để đồng bộ visual với các field optional khác trong form. -->
    <b-form-group :disabled="disabled || isDisabled">
      <label>Nhân viên kỹ thuật:</label>
      <i
        class="fas fa-exclamation-circle text-warning ml-2 icon-size"
        v-show="showWarning('Assistant')"
        :title="'Nhân viên chưa được lưu'"
      ></i>
      <Autosuggest
        :disabled="disabled || isDisabled"
        :model.sync="contractEmployeeInfo.assistantName"
        :suggestions="filteredEmployeeOptions"
        :placeholder="'Nhân viên kỹ thuật'"
        :limit="10"
        @select="onSelected($event, 'Assistant')"
        @change="onInputChange"
        @focus="onFocusInput(jobTitle.TL)"
      >
        <template #custom="{ suggestion }">
          <div>
            <span>{{ suggestion.item.fullName }}</span>
            <span class="text-primary" v-if="suggestion.item.code">
              - {{ suggestion.item.code }}
            </span>
          </div>
        </template>
      </Autosuggest>
    </b-form-group>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { JOB_TITLE } from '../../../utils/enum';
import { xoa_dau } from '../../../utils/common';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  props: [
    'storeId',
    'contractDataEmployeeInfo',
    'disabled',
    'contractData',
    'isDisabled',
  ],
  components: { Autosuggest },
  data() {
    return {
      filteredOptionsSale: [],
      filteredEmployeeOptions: [],
      optionsEmployee: [
        {
          data: [],
        },
      ],
      jobTitle: JOB_TITLE,
      contractEmployeeInfo: {
        saleId: null,
        saleName: '',
        technicalId: null,
        technicalName: '',
        cashierId: null,
        cashierName: '',
        accessoryStaffId: null,
        accessoryStaffName: '',
        managerId: null,
        managerName: '',
        assistantId: null,
        assistantName: '',
        customerReceptionId: null,
        customerReceptionName: '',
        shipperId: null,
        shipperName: '',
      },
      contractDataEmployee: null,
    };
  },
  computed: {},
  beforeUpdate() {
    this.contractEmployeeInfo = this.contractDataEmployeeInfo;
    this.contractDataEmployee = this.contractDataEmployeeInfo;
  },
  mounted() {
    this.contractEmployeeInfo = this.contractDataEmployeeInfo;
    this.contractDataEmployee = this.contractDataEmployeeInfo;
    if (this.storeId) {
      this.fetchEmployeeByStore();
    }
  },
  watch: {
    storeId: {
      handler: function (newValue, oldValue) {
        let isChangeStore = false;
        if (oldValue && oldValue !== newValue) {
          isChangeStore = true;
        }
        this.fetchEmployeeByStore(isChangeStore);
      },
    },
  },
  methods: {
    onSelected(option, type) {
      switch (type) {
        case 'Sale':
          this.contractEmployeeInfo.saleId = option.item.id;
          this.contractEmployeeInfo.saleName = option.item.fullName;
          this.contractDataEmployee.saleId = option.item.id;
          this.contractData.saleId = option.item.id;
          this.contractData.saleName = option.item.fullName;

          break;
        case 'Technical':
          this.contractEmployeeInfo.technicalId = option.item.id;
          this.contractEmployeeInfo.technicalName = option.item.fullName;
          this.contractDataEmployee.technicalId = option.item.id;
          // Phase B — propagate lên `contractData` (prop từ parent Upsert.vue) để
          // save payload include `technicalId/Name`. Cùng pattern với Sale/Shipper.
          this.contractData.technicalId = option.item.id;
          this.contractData.technicalName = option.item.fullName;
          break;
        case 'Accessory':
          this.contractEmployeeInfo.accessoryStaffId = option.item.id;
          this.contractEmployeeInfo.accessoryStaffName = option.item.fullName;
          this.contractDataEmployee.accessoryStaffId = option.item.id;
          break;
        case 'Cashier':
          this.contractEmployeeInfo.cashierId = option.item.id;
          this.contractEmployeeInfo.cashierName = option.item.fullName;
          this.contractDataEmployee.cashierId = option.item.id;
          this.contractData.cashierId = option.item.id;
          this.contractData.cashierName = option.item.fullName;
          break;
        case 'Manager':
          this.contractEmployeeInfo.managerId = option.item.id;
          this.contractEmployeeInfo.managerName = option.item.fullName;
          this.contractDataEmployee.managerId = option.item.id;
          this.contractData.managerId = option.item.id;
          this.contractData.managerName = option.item.fullName;
          break;
        case 'Assistant':
          this.contractEmployeeInfo.assistantId = option.item.id;
          this.contractEmployeeInfo.assistantName = option.item.fullName;
          this.contractDataEmployee.assistantId = option.item.id;
          this.contractData.assistantId = option.item.id;
          this.contractData.assistantName = option.item.fullName;
          break;
        case 'CustomerReception':
          this.contractEmployeeInfo.customerReceptionId = option.item.id;
          this.contractEmployeeInfo.customerReceptionName =
            option.item.fullName;
          this.contractDataEmployee.customerReceptionId = option.item.id;
          break;
        case 'Shipper':
          this.contractEmployeeInfo.shipperId = option.item.id;
          this.contractEmployeeInfo.shipperName = option.item.fullName;
          this.contractDataEmployee.shipperId = option.item.id;
          this.contractData.shipperId = option.item.id;
          this.contractData.shipperName = option.item.fullName;
          break;
      }
    },
    onInputChange(text) {
      if (!text) {
        text = '';
      }

      const filteredData = this.optionsEmployee[0].data
        .filter((item) => {
          const nameNoneSign = xoa_dau(item.fullName);
          return (
            nameNoneSign.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.fullName.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.code.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);

      this.filteredEmployeeOptions = filteredData;
    },
    fetchEmployeeByStore(isChangeStore) {
      if (isChangeStore) {
        this.contractDataEmployee = {};
        this.contractEmployeeInfo = {};
      }
      // Chưa chọn cửa hàng thì không gọi API (BE yêu cầu storeId bắt buộc).
      if (!this.storeId) {
        this.optionsEmployee[0].data = [];
        this.filteredEmployeeOptions = [];
        return;
      }
      ApiService.get(`users/get-by-store?storeId=${this.storeId}`).then((data) => {
        const employees = data.data.data;
        this.optionsEmployee[0].data = employees.map((item) => {
          return {
            id: item.id,
            code: item.code ? item.code : '',
            fullName: item.fullName ? item.fullName : '',
            jobTitleId: item.jobTitleId,
          };
        });
        this.filteredEmployeeOptions = [...this.optionsEmployee[0].data];
      });
    },
    onFocusInput(jobTitleId) {
      const suggesstionData = this.sortEmpByJobTitle(jobTitleId);
      this.filteredEmployeeOptions = [...suggesstionData];
    },
    sortEmpByJobTitle(jobTitleId) {
      const empJobs = this.optionsEmployee[0].data.filter(
        (emp) => emp.jobTitleId === jobTitleId,
      );
      const empDiffJobs = this.optionsEmployee[0].data.filter(
        (emp) => emp.jobTitleId !== jobTitleId,
      );
      return empJobs.concat(empDiffJobs);
    },
    showWarning(type) {
      if (!this.contractDataEmployee) {
        return false;
      }
      switch (type) {
        case 'Sale':
          if (!this.contractDataEmployee.saleId) {
            return true;
          }

          return false;
        case 'Technical':
          if (!this.contractDataEmployee.technicalId) {
            return true;
          }

          return false;
        case 'Accessory':
          if (!this.contractDataEmployee.accessoryStaffId) {
            return true;
          }

          return false;
        case 'Cashier':
          if (!this.contractDataEmployee.cashierId) {
            return true;
          }

          return false;
        case 'Manager':
          if (!this.contractDataEmployee.managerId) {
            return true;
          }

          return false;
        case 'Assistant':
          if (!this.contractDataEmployee.assistantId) {
            return true;
          }

          return false;
        case 'CustomerReception':
          if (!this.contractDataEmployee.customerReceptionId) {
            return true;
          }

          return false;
        case 'Shipper':
          if (!this.contractDataEmployee.shipperId) {
            return true;
          }

          return false;
        default:
          return false;
      }
    },
  },
};
</script>

<style lang="scss">
.contract-employee {
  .icon-size {
    font-size: 1rem !important;
  }
}
</style>
